


export const sldsColors = [
    {color: '#03234d', colorClass: 'blue-1', group: 'blue'},
    {color: '#032d60', colorClass: 'blue-2', group: 'blue'},
    {color: '#014486', colorClass: 'blue-3', group: 'blue'},
    {color: '#0b5cab', colorClass: 'blue-4', group: 'blue'},
    {color: '#0176d3', colorClass: 'blue-5', group: 'blue'},
    {color: '#1b96ff', colorClass: 'blue-6', group: 'blue'},
    {color: '#57a3fd', colorClass: 'blue-7', group: 'blue'},
    {color: '#78b0fd', colorClass: 'blue-8', group: 'blue'},
    {color: '#aacbff', colorClass: 'blue-9', group: 'blue'},
    {color: '#0a2636', colorClass: 'cloud-blue-2', group: 'cloudBlue'},
    {color: '#023248', colorClass: 'cloud-blue-3', group: 'cloudBlue'},
    {color: '#084968', colorClass: 'cloud-blue-4', group: 'cloudBlue'},
    {color: '#05628a', colorClass: 'cloud-blue-5', group: 'cloudBlue'},
    {color: '#107cad', colorClass: 'cloud-blue-6', group: 'cloudBlue'},
    {color: '#0d9dda', colorClass: 'cloud-blue-7', group: 'cloudBlue'},
    {color: '#08abed', colorClass: 'cloud-blue-8', group: 'cloudBlue'},
    {color: '#1ab9ff', colorClass: 'cloud-blue-9', group: 'cloudBlue'},
    {color: '#90d0fe', colorClass: 'cloud-blue-10', group: 'cloudBlue'},
    {color: '#1c3326', colorClass: 'green-3', group: 'green'},
    {color: '#194e31', colorClass: 'green-4', group: 'green'},
    {color: '#396547', colorClass: 'green-5', group: 'green'},
    {color: '#2e844a', colorClass: 'green-6', group: 'green'},
    {color: '#3ba755', colorClass: 'green-7', group: 'green'},
    {color: '#41b658', colorClass: 'green-8', group: 'green'},
    {color: '#45c65a', colorClass: 'green-9', group: 'green'},
    {color: '#91db8b', colorClass: 'green-10', group: 'green'},
    {color: '#cdefc4', colorClass: 'green-11', group: 'green'},
    {color: '#421604', colorClass: 'hot-orange-2', group: 'hotOrange'},
    {color: '#4a2413', colorClass: 'hot-orange-3', group: 'hotOrange'},
    {color: '#7e2600', colorClass: 'hot-orange-4', group: 'hotOrange'},
    {color: '#aa3001', colorClass: 'hot-orange-5', group: 'hotOrange'},
    {color: '#d83a00', colorClass: 'hot-orange-6', group: 'hotOrange'},
    {color: '#ff5d2d', colorClass: 'hot-orange-7', group: 'hotOrange'},
    {color: '#ff784f', colorClass: 'hot-orange-8', group: 'hotOrange'},
    {color: '#ff906e', colorClass: 'hot-orange-9', group: 'hotOrange'},
    {color: '#feb9a5', colorClass: 'hot-orange-10', group: 'hotOrange'}, 
    {color: '#1f0974', colorClass: 'indigo-2', group: 'indigo'},
    {color: '#321d71', colorClass: 'indigo-3', group: 'indigo'},   
    {color: '#2f2cb7', colorClass: 'indigo-4', group: 'indigo'},
    {color: '#3a49da', colorClass: 'indigo-5', group: 'indigo'},
    {color: '#5867e8', colorClass: 'indigo-6', group: 'indigo'},
    {color: '#7f8ced', colorClass: 'indigo-7', group: 'indigo'},
    {color: '#8e9bef', colorClass: 'indigo-8', group: 'indigo'},
    {color: '#9ea9f1', colorClass: 'indigo-9', group: 'indigo'},
    {color: '#bec7f6', colorClass: 'indigo-10', group: 'indigo'},
    {color: '#3e2b02', colorClass: 'orange-3', group: 'orange'},
    {color: '#5f3e02', colorClass: 'orange-4', group: 'orange'},
    {color: '#825101', colorClass: 'orange-5', group: 'orange'},
    {color: '#a96404', colorClass: 'orange-6', group: 'orange'},
    {color: '#dd7a01', colorClass: 'orange-7', group: 'orange'},
    {color: '#f38303', colorClass: 'orange-8', group: 'orange'},
    {color: '#fe9339', colorClass: 'orange-9', group: 'orange'},
    {color: '#ffba90', colorClass: 'orange-10', group: 'orange'},
    {color: '#ffba90', colorClass: 'orange-11', group: 'orange'},
    {color: '#8a033e', colorClass: 'pink-2', group: 'pink'},
    {color: '#8a033e', colorClass: 'pink-3', group: 'pink'},
    {color: '#8a033e', colorClass: 'pink-4', group: 'pink'},
    {color: '#b60554', colorClass: 'pink-5', group: 'pink'},
    {color: '#e3066a', colorClass: 'pink-6', group: 'pink'},
    {color: '#ff538a', colorClass: 'pink-7', group: 'pink'},
    {color: '#fe7298', colorClass: 'pink-8', group: 'pink'},
    {color: '#fe8aa7', colorClass: 'pink-9', group: 'pink'},
    {color: '#fdb6c5', colorClass: 'pink-10', group: 'pink'},
    {color: '#5a1ba9', colorClass: 'purple-3', group: 'purple'},
    {color: '#5a1ba9', colorClass: 'purple-4', group: 'purple'},
    {color: '#7526e3', colorClass: 'purple-5', group: 'purple'},
    {color: '#9050e9', colorClass: 'purple-6', group: 'purple'},
    {color: '#ad7bee', colorClass: 'purple-7', group: 'purple'},
    {color: '#b78def', colorClass: 'purple-8', group: 'purple'},
    {color: '#c29ef1', colorClass: 'purple-9', group: 'purple'},
    {color: '#d7bff2', colorClass: 'purple-10', group: 'purple'},
    {color: '#ece1f9', colorClass: 'purple-11', group: 'purple'},
    {color: '#640103', colorClass: 'red-3', group: 'red'},
    {color: '#8e030f', colorClass: 'red-4', group: 'red'},
    {color: '#ba0517', colorClass: 'red-5', group: 'red'},
    {color: '#ea001e', colorClass: 'red-6', group: 'red'},
    {color: '#fe5c4c', colorClass: 'red-7', group: 'red'},
    {color: '#fe7765', colorClass: 'red-8', group: 'red'},
    {color: '#fe8f7d', colorClass: 'red-9', group: 'red'},
    {color: '#feb8ab', colorClass: 'red-10', group: 'red'},
    {color: '#feded8', colorClass: 'red-11', group: 'red'},
    {color: '#023434', colorClass: 'teal-3', group: 'teal'},
    {color: '#024d4c', colorClass: 'teal-4', group: 'teal'},
    {color: '#056764', colorClass: 'teal-5', group: 'teal'},
    {color: '#0b827c', colorClass: 'teal-6', group: 'teal'},
    {color: '#06a59a', colorClass: 'teal-7', group: 'teal'},
    {color: '#03b4a7', colorClass: 'teal-8', group: 'teal'},
    {color: '#01c3b3', colorClass: 'teal-9', group: 'teal'},
    {color: '#04e1cb', colorClass: 'teal-10', group: 'teal'},
    {color: '#acf3e4', colorClass: 'teal-11', group: 'teal'},
    {color: '#481a54', colorClass: 'violet-3', group: 'violet'},
    {color: '#730394', colorClass: 'violet-4', group: 'violet'},
    {color: '#9602c7', colorClass: 'violet-5', group: 'violet'},
    {color: '#ba01ff', colorClass: 'violet-6', group: 'violet'},
    {color: '#cb65ff', colorClass: 'violet-7', group: 'violet'},
    {color: '#d17dfe', colorClass: 'violet-8', group: 'violet'},
    {color: '#d892fe', colorClass: 'violet-9', group: 'violet'},
    {color: '#e5b9fe', colorClass: 'violet-10', group: 'violet'},
    {color: '#f2defe', colorClass: 'violet-11', group: 'violet'},
    {color: '#4f2100', colorClass: 'yellow-3', group: 'yellow'},
    {color: '#6f3400', colorClass: 'yellow-4', group: 'yellow'},
    {color: '#8c4b02', colorClass: 'yellow-5', group: 'yellow'},
    {color: '#a86403', colorClass: 'yellow-6', group: 'yellow'},
    {color: '#ca8501', colorClass: 'yellow-7', group: 'yellow'},
    {color: '#d79304', colorClass: 'yellow-8', group: 'yellow'},
    {color: '#e4a201', colorClass: 'yellow-9', group: 'yellow'},
    {color: '#fcc003', colorClass: 'yellow-10', group: 'yellow'},
    {color: '#f9e3b6', colorClass: 'yellow-11', group: 'yellow'},
    {color: '#181818', colorClass: 'neutral-1', group: 'neutral'},
    {color: '#242424', colorClass: 'neutral-2', group: 'neutral'},
    {color: '#2e2e2e', colorClass: 'neutral-3', group: 'neutral'},
    {color: '#5c5c5c', colorClass: 'neutral-5', group: 'neutral'},
    {color: '#747474', colorClass: 'neutral-6', group: 'neutral'},
    {color: '#a0a0a0', colorClass: 'neutral-8', group: 'neutral'},
    {color: '#aeaeae', colorClass: 'neutral-9', group: 'neutral'},
    {color: '#e5e5e5', colorClass: 'neutral-11', group: 'neutral'},
    {color: '#f3f3f3', colorClass: 'neutral-12', group: 'neutral'},
];



export const sldsColorsGrouped = [
    {
        blue: [
            {color: '#001639', colorClass: 'slds-swatch blue-0'},
            {color: '#03234d', colorClass: 'slds-swatch blue-1'},
            {color: '#032d60', colorClass: 'slds-swatch blue-2'},
            {color: '#014486', colorClass: 'slds-swatch blue-3'},
            {color: '#0b5cab', colorClass: 'slds-swatch blue-4'},
            {color: '#0176d3', colorClass: 'slds-swatch blue-5'},
            {color: '#1b96ff', colorClass: 'slds-swatch blue-6'},
            {color: '#57a3fd', colorClass: 'slds-swatch blue-7'},
            {color: '#78b0fd', colorClass: 'slds-swatch blue-8'},
            {color: '#aacbff', colorClass: 'slds-swatch blue-9'},
        ]
    },
    {
        cloudBlue: [
            {color: '#001a28', colorClass: 'slds-swatch cloud-blue-1'},
            {color: '#0a2636', colorClass: 'slds-swatch cloud-blue-2'},
            {color: '#023248', colorClass: 'slds-swatch cloud-blue-3'},
            {color: '#084968', colorClass: 'slds-swatch cloud-blue-4'},
            {color: '#05628a', colorClass: 'slds-swatch cloud-blue-5'},
            {color: '#107cad', colorClass: 'slds-swatch cloud-blue-6'},
            {color: '#0d9dda', colorClass: 'slds-swatch cloud-blue-7'},
            {color: '#08abed', colorClass: 'slds-swatch cloud-blue-8'},
            {color: '#1ab9ff', colorClass: 'slds-swatch cloud-blue-9'},
            {color: '#90d0fe', colorClass: 'slds-swatch cloud-blue-10'},
            {color: '#cfe9fe', colorClass: 'slds-swatch cloud-blue-11'},
            {color: '#eaf5fe', colorClass: 'slds-swatch cloud-blue-12'},
        ]
    },
    {
        green: [
            {color: '#071b12', colorClass: 'slds-swatch green-1'},
            {color: '#0c2912', colorClass: 'slds-swatch green-2'},
            {color: '#1c3326', colorClass: 'slds-swatch green-3'},
            {color: '#194e31', colorClass: 'slds-swatch green-4'},
            {color: '#396547', colorClass: 'slds-swatch green-5'},
            {color: '#2e844a', colorClass: 'slds-swatch green-6'},
            {color: '#3ba755', colorClass: 'slds-swatch green-7'},
            {color: '#41b658', colorClass: 'slds-swatch green-8'},
            {color: '#45c65a', colorClass: 'slds-swatch green-9'},
            {color: '#91db8b', colorClass: 'slds-swatch green-10'},
            {color: '#cdefc4', colorClass: 'slds-swatch green-11'},
            {color: '#ebf7e6', colorClass: 'slds-swatch green-12'},
        ]
    },
    {
        hotOrange: [
            {color: '#281202', colorClass: 'slds-swatch hot-orange-1'},
            {color: '#421604', colorClass: 'slds-swatch hot-orange-2'},
            {color: '#4a2413', colorClass: 'slds-swatch hot-orange-3'},
            {color: '#7e2600', colorClass: 'slds-swatch hot-orange-4'},
            {color: '#aa3001', colorClass: 'slds-swatch hot-orange-5'},
            {color: '#d83a00', colorClass: 'slds-swatch hot-orange-6'},
            {color: '#ff5d2d', colorClass: 'slds-swatch hot-orange-7'},
            {color: '#ff784f', colorClass: 'slds-swatch hot-orange-8'},
            {color: '#ff906e', colorClass: 'slds-swatch hot-orange-9'},
            {color: '#feb9a5', colorClass: 'slds-swatch hot-orange-10'},
            {color: '#ffded5', colorClass: 'slds-swatch hot-orange-11'},
            {color: '#fef1ed', colorClass: 'slds-swatch hot-orange-12'},
        ]
    },
    {
        indigo: [
            {color: '#200647', colorClass: 'slds-swatch indigo-1'},
            {color: '#1f0974', colorClass: 'slds-swatch indigo-2'},
            {color: '#321d71', colorClass: 'slds-swatch indigo-3'},
            {color: '#2f2cb7', colorClass: 'slds-swatch indigo-4'},
            {color: '#3a49da', colorClass: 'slds-swatch indigo-5'},
            {color: '#5867e8', colorClass: 'slds-swatch indigo-6'},
            {color: '#7f8ced', colorClass: 'slds-swatch indigo-7'},
            {color: '#8e9bef', colorClass: 'slds-swatch indigo-8'},
            {color: '#9ea9f1', colorClass: 'slds-swatch indigo-9'},
            {color: '#bec7f6', colorClass: 'slds-swatch indigo-10'},
            {color: '#e0e5f8', colorClass: 'slds-swatch indigo-11'},
            {color: '#f1f3fb', colorClass: 'slds-swatch indigo-12'},
        ]
    },
    {
        orange: [
            {color: '#201600', colorClass: 'slds-swatch orange-1'},
            {color: '#371e03', colorClass: 'slds-swatch orange-2'},
            {color: '#3e2b02', colorClass: 'slds-swatch orange-3'},
            {color: '#5f3e02', colorClass: 'slds-swatch orange-4'},
            {color: '#825101', colorClass: 'slds-swatch orange-5'},
            {color: '#a96404', colorClass: 'slds-swatch orange-6'},
            {color: '#dd7a01', colorClass: 'slds-swatch orange-7'},
            {color: '#f38303', colorClass: 'slds-swatch orange-8'},
            {color: '#fe9339', colorClass: 'slds-swatch orange-9'},
            {color: '#ffba90', colorClass: 'slds-swatch orange-10'},
            {color: '#fedfd0', colorClass: 'slds-swatch orange-11'},
            {color: '#fff1ea', colorClass: 'slds-swatch orange-12'},
        ]
    },
    {
        pink: [
            {color: '#370114', colorClass: 'slds-swatch pink-1'},
            {color: '#4b0620', colorClass: 'slds-swatch pink-2'},
            {color: '#61022a', colorClass: 'slds-swatch pink-3'},
            {color: '#8a033e', colorClass: 'slds-swatch pink-4'},
            {color: '#b60554', colorClass: 'slds-swatch pink-5'},
            {color: '#e3066a', colorClass: 'slds-swatch pink-6'},
            {color: '#ff538a', colorClass: 'slds-swatch pink-7'},
            {color: '#fe7298', colorClass: 'slds-swatch pink-8'},
            {color: '#fe8aa7', colorClass: 'slds-swatch pink-9'},
            {color: '#fdb6c5', colorClass: 'slds-swatch pink-10'},
            {color: '#fddde3', colorClass: 'slds-swatch pink-11'},
            {color: '#fef0f3', colorClass: 'slds-swatch pink-12'},
        ]
    },
    {
        purple: [
            {color: '#240643', colorClass: 'slds-swatch purple-1'},
            {color: '#300b60', colorClass: 'slds-swatch purple-2'},
            {color: '#401075', colorClass: 'slds-swatch purple-3'},
            {color: '#5a1ba9', colorClass: 'slds-swatch purple-4'},
            {color: '#7526e3', colorClass: 'slds-swatch purple-5'},
            {color: '#9050e9', colorClass: 'slds-swatch purple-6'},
            {color: '#ad7bee', colorClass: 'slds-swatch purple-7'},
            {color: '#b78def', colorClass: 'slds-swatch purple-8'},
            {color: '#c29ef1', colorClass: 'slds-swatch purple-9'},
            {color: '#d7bff2', colorClass: 'slds-swatch purple-10'},
            {color: '#ece1f9', colorClass: 'slds-swatch purple-11'},
            {color: '#f6f2fb', colorClass: 'slds-swatch purple-12'},
        ]
    },
    {
        red: [
            {color: '#300c01', colorClass: 'slds-swatch red-1'},
            {color: '#4a0c04', colorClass: 'slds-swatch red-2'},
            {color: '#640103', colorClass: 'slds-swatch red-3'},
            {color: '#8e030f', colorClass: 'slds-swatch red-4'},
            {color: '#ba0517', colorClass: 'slds-swatch red-5'},
            {color: '#ea001e', colorClass: 'slds-swatch red-6'},
            {color: '#fe5c4c', colorClass: 'slds-swatch red-7'},
            {color: '#fe7765', colorClass: 'slds-swatch red-8'},
            {color: '#fe8f7d', colorClass: 'slds-swatch red-9'},
            {color: '#feb8ab', colorClass: 'slds-swatch red-10'},
            {color: '#feded8', colorClass: 'slds-swatch red-11'},
            {color: '#fef1ee', colorClass: 'slds-swatch red-12'},
        ]
    },
    {
        teal: [
            {color: '#071b12', colorClass: 'slds-swatch teal-1'},
            {color: '#072825', colorClass: 'slds-swatch teal-2'},
            {color: '#023434', colorClass: 'slds-swatch teal-3'},
            {color: '#024d4c', colorClass: 'slds-swatch teal-4'},
            {color: '#056764', colorClass: 'slds-swatch teal-5'},
            {color: '#0b827c', colorClass: 'slds-swatch teal-6'},
            {color: '#06a59a', colorClass: 'slds-swatch teal-7'},
            {color: '#03b4a7', colorClass: 'slds-swatch teal-8'},
            {color: '#01c3b3', colorClass: 'slds-swatch teal-9'},
            {color: '#04e1cb', colorClass: 'slds-swatch teal-10'},
            {color: '#acf3e4', colorClass: 'slds-swatch teal-11'},
            {color: '#def9f3', colorClass: 'slds-swatch teal-12'},
        ]
    },
    {
        violet: [
            {color: '#2e0039', colorClass: 'slds-swatch violet-1'},
            {color: '#3d0157', colorClass: 'slds-swatch violet-2'},
            {color: '#481a54', colorClass: 'slds-swatch violet-3'},
            {color: '#730394', colorClass: 'slds-swatch violet-4'},
            {color: '#9602c7', colorClass: 'slds-swatch violet-5'},
            {color: '#ba01ff', colorClass: 'slds-swatch violet-6'},
            {color: '#cb65ff', colorClass: 'slds-swatch violet-7'},
            {color: '#d17dfe', colorClass: 'slds-swatch violet-8'},
            {color: '#d892fe', colorClass: 'slds-swatch violet-9'},
            {color: '#e5b9fe', colorClass: 'slds-swatch violet-10'},
            {color: '#f2defe', colorClass: 'slds-swatch violet-11'},
            {color: '#f9f0ff', colorClass: 'slds-swatch violet-12'},
        ]
    },
    {
        yellow: [
            {color: '#281202', colorClass: 'slds-swatch yellow-1'},
            {color: '#2e2204', colorClass: 'slds-swatch yellow-2'},
            {color: '#4f2100', colorClass: 'slds-swatch yellow-3'},
            {color: '#6f3400', colorClass: 'slds-swatch yellow-4'},
            {color: '#8c4b02', colorClass: 'slds-swatch yellow-5'},
            {color: '#a86403', colorClass: 'slds-swatch yellow-6'},
            {color: '#ca8501', colorClass: 'slds-swatch yellow-7'},
            {color: '#d79304', colorClass: 'slds-swatch yellow-8'},
            {color: '#e4a201', colorClass: 'slds-swatch yellow-9'},
            {color: '#fcc003', colorClass: 'slds-swatch yellow-10'},
            {color: '#f9e3b6', colorClass: 'slds-swatch yellow-11'},
            {color: '#fbf3e0', colorClass: 'slds-swatch yellow-12'},
        ]
    }, 
    {
        neutral: [
            {color: '#181818', colorClass: 'slds-swatch neutral-1'},
            {color: '#242424', colorClass: 'slds-swatch neutral-2'},
            {color: '#2e2e2e', colorClass: 'slds-swatch neutral-3'},
            {color: '#444', colorClass: 'slds-swatch neutral-4'},
            {color: '#5c5c5c', colorClass: 'slds-swatch neutral-5'},
            {color: '#747474', colorClass: 'slds-swatch neutral-6'},
            {color: '#939393', colorClass: 'slds-swatch neutral-7'},
            {color: '#a0a0a0', colorClass: 'slds-swatch neutral-8'},
            {color: '#aeaeae', colorClass: 'slds-swatch neutral-9'},
            {color: '#c9c9c9', colorClass: 'slds-swatch neutral-10'},
            {color: '#e5e5e5', colorClass: 'slds-swatch neutral-11'},
            {color: '#f3f3f3', colorClass: 'slds-swatch neutral-12'},
        ]  
    },
];



export const bestSldsColorsMap = {
    cloudBlue: ['cloud-blue-6', 'cloud-blue-7', 'cloud-blue-8', 'cloud-blue-9', 'cloud-blue-10',],
    hotOrange: ['hot-orange-6', 'hot-orange-7', 'hot-orange-8', 'hot-orange-9', 'hot-orange-10',],
    green: ['green-6','green-7','green-8','green-9','green-10',],
    pink: ['pink-6', 'pink-7', 'pink-8', 'pink-9', 'pink-10',],
    red: ['red-6', 'red-7', 'red-8', 'red-9', 'red-10',],
    yellow: ['yellow-6', 'yellow-7', 'yellow-8', 'yellow-9', 'yellow-10',],
    indigo: ['indigo-4', 'indigo-5', 'indigo-6', 'indigo-7'],
    purple: ['purple-4', 'purple-5', 'purple-6', 'purple-7'],
    teal: ['teal-5', 'teal-6', 'teal-7', 'teal-8', 'teal-9', 'teal-10',],
    blue: ['blue-3', 'blue-4', 'blue-5', 'blue-6', 'blue-7', 'blue-8',],
    violet: [ 'violet-4', 'violet-5', 'violet-6', 'violet-7', 'violet-8', 'violet-9',],
    orange: ['orange-6','orange-7','orange-8','orange-9','orange-10',],
    neutral: [],
};

